import { MailOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Card, Divider, Timeline, Typography } from 'antd';
import moment from 'moment';

import useAPIQuery from '../../api/useAPIQuery';
import { EmailCommunicationDetailSerializer } from '../../types/api';
import style from './ApplicantMindsightMessageTimeline.module.css';

interface AttachmentLinkProps {
  attachmentId: number;
}

const AttachmentLink = ({ attachmentId }: AttachmentLinkProps) => {
  const attachment = useAPIQuery(`/attachments/${attachmentId}/`);

  return (
    <Typography.Paragraph>
      <Typography.Link href={attachment.data?.file ?? ''} target="_blank">
        <PaperClipOutlined /> {attachment.data?.filename}
      </Typography.Link>
    </Typography.Paragraph>
  );
};

interface ApplicantMessageTimelineProps {
  opportunityTitle?: string;
  recruiterName?: string;
  createdAt: string;
  emailCommunication: EmailCommunicationDetailSerializer;
}

const ApplicantMessageTimeline = ({
  emailCommunication,
  opportunityTitle,
  recruiterName,
  createdAt,
}: ApplicantMessageTimelineProps) => {
  const automaticSentString = recruiterName ? 'enviou' : 'enviou automaticamente';

  return (
    <Timeline.Item dot={<MailOutlined />}>
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdAt).format('LLL')}</Typography.Text>
          <br />
          <Typography.Text strong>{recruiterName || 'O sistema'} </Typography.Text>
          <Typography.Text>
            {emailCommunication.type === 'COMMUNICATION' && (
              <span>
                {automaticSentString} uma <Typography.Text strong>comunicação</Typography.Text>
              </span>
            )}
            {emailCommunication.type === 'PRACTICAL_TECHNICAL_CASE' && (
              <span>
                {automaticSentString} um{' '}
                <Typography.Text strong>case prático ou técnico</Typography.Text>
              </span>
            )}
            {emailCommunication.type === 'TESTS' && (
              <span>
                {automaticSentString} os <Typography.Text strong>testes</Typography.Text>
              </span>
            )}
            {emailCommunication.type === 'ADDITIONAL_QUESTIONS' && (
              <span>
                {automaticSentString}{' '}
                <Typography.Text strong>perguntas de pré-requisito</Typography.Text>
              </span>
            )}
            {emailCommunication.type === 'CUSTOM_TESTS' && (
              <span>
                {automaticSentString} os{' '}
                <Typography.Text strong>testes customizados</Typography.Text>
              </span>
            )}
            {emailCommunication.type === 'WELCOME_MESSAGE' && (
              <span>
                {automaticSentString} uma{' '}
                <Typography.Text strong>mensagem de boas vindas</Typography.Text>
              </span>
            )}
            <span>, via e-mail, para o(a) candidato(a)</span>
            {opportunityTitle && (
              <span>
                {' '}
                na vaga <Typography.Text strong>{opportunityTitle}</Typography.Text>
              </span>
            )}
          </Typography.Text>
        </Typography.Paragraph>
        <Divider />
        <div
          dangerouslySetInnerHTML={{ __html: emailCommunication.message || '' }}
          className={style.emailMessage}
        />
        {emailCommunication.type !== 'TESTS' &&
          emailCommunication.attachments.map((attachmentId) => (
            <AttachmentLink attachmentId={attachmentId} />
          ))}
      </Card>
    </Timeline.Item>
  );
};

export default ApplicantMessageTimeline;
